import React from "react";
import "./PayRoll.css";
import { Navbar } from "react-bootstrap";

const PayRoll = () => {
  return (
    <div>
      <Navbar> </Navbar>
      <div className="payroll-container">
        <img src="./images/Commingsoon.jpg" alt="Commingsoon...." />
      </div>
    </div>
  );
};

export default PayRoll;
